module.exports = __webpack_public_path__ + "static/media/osg-logo.e3ae7558.png";